/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'secarrow': {
    width: 11,
    height: 8,
    viewBox: '0 0 11 8',
    data: '<path pid="0" d="M.522 6.581a.577.577 0 0 1 .115-.363L5.253.212A.343.343 0 0 1 5.52.065c.102 0 .2.052.272.147l4.616 6.006c.15.19.154.502.008.698a.343.343 0 0 1-.273.149H.908c-.21.005-.382-.212-.386-.484z" _fill="#EB5D58" fill-rule="evenodd"/>'
  }
})
